import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../config/httpConfig";

export const dealsView = createAsyncThunk(
  "deals/dealsView",
  async ({ selectedStatus, dealCategoryId }) => {
    const formattedStatus = Array.isArray(selectedStatus) ? selectedStatus.join(",") : selectedStatus;
    const response = await axios.get(
      `/api/admin/dealsView?statusId=${formattedStatus}&dealCategoryId=${dealCategoryId}`
    );
    return response.response;
  }
);

export const dealsUnderBusiness = createAsyncThunk(
  "deals/dealsUnderBusiness",
  async (orgId) => {
    const response = await axios.get(
      `/api/admin/dealsUnderBusiness?orgId=${orgId}`
    );
    return response.response;
  }
);

export const approveDeals = createAsyncThunk(
  "deals/approveDeals",
  async (dealId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/admin/getApproveDeal?dealId=${dealId}`
      );
      return response.response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const dealDetailedView = createAsyncThunk(
  "deals/dealDetailedView",
  async (dealId) => {
    const response = await axios.get(
      `/api/admin/dealDetailedView?dealId=${dealId}`
    );
    return response.response;
  }
);

export const approvependingdeal = createAsyncThunk(
  "deals/approvependingdeal",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/approveDeal", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);
export const Rejectdeal = createAsyncThunk(
  "deals/Rejectdeal",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/rejectDeal", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);
export const sendaggrement = createAsyncThunk(
  "deals/sendaggrement",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/sendToAgreement", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);
export const Cancledeal = createAsyncThunk(
  "deals/Cancledeal",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/cancelDeal", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const Disbursedeal = createAsyncThunk(
  "deals/Disbursedeal",
  async (dealId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/admin/disburseDeal?dealId=${dealId}`
      );
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const getAggrementStatus = createAsyncThunk(
  "deals/getAggrementStatus",
  async (dealId) => {
    const response = await axios.get(
      `/api/admin/getAggrementStatus?dealId=${dealId}`
    );
    return response;
  }
);

export const sendAgreementReminder = createAsyncThunk(
  "deals/sendAgreementReminder",
  async (payload) => {
    const response = await axios.post(
      `/api/admin/sendAgreementReminder`,
      payload
    );
    return response;
  }
);

export const sendRepaymentReminder = createAsyncThunk(
  "deals/sendRepaymentReminder",
  async (payload) => {
    const response = await axios.post(
      `/api/admin/sendRepaymentReminder`,
      payload
    );
    return response;
  }
);

export const sendOverdueReminder = createAsyncThunk(
  "deals/sendOverdueReminder",
  async (payload) => {
    const response = await axios.post(
      `/api/admin/sendOverdueReminder`,
      payload
    );
    return response;
  }
);

export const Republishdeal = createAsyncThunk(
  "deals/Republishdeal",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/republishDeal", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const dealLevelFunding = createAsyncThunk(
  "deals/dealLevelFunding",
  async (statusId) => {
    const response = await axios.get(
      `/api/admin/dealLevelFunding?statusId=${statusId}`
    );
    return response.response;
  }
);

export const count = createAsyncThunk(
  "deals/count",
  async (type) => {
    const response = await axios.get(`/api/admin/count/${type}`);
    return response.response || [];
  }
);

export const getExpiryDays = createAsyncThunk(
  "deals/getExpiryDays",
  async () => {
    const response = await axios.get(`/api/admin/getExpiryDays`);
    return response.response;
  }
);

export const dealsSlice = createSlice({
  name: "deals",
  initialState: {
    loading: false,
    status: [],
    dealView: [],
    approvedeal: [],
    dealunderBus: [],
    statusData: {},
    detailedview: [],
    approvedealform: {},
    disburseDealform: [],
    republishDealform: {},
    republishError: "",
    cancleDealform: {},
    rejectDealform: {},
    sendagreeform: {},
    fundDeals: [],
    expiryDays: [],
    error: "",
    cancelError: "",
    cancelLoading: false,
    disburseError: "",
    disburseLoading: false,
    aggrementData: {},
    approveSubmitLoading: false,
    sendAgreeloading: false,
    agreeStatusloading: false,
    sendRemainderLoading: false,
    CountData: [],
  },

  extraReducers: (builder) => {
    builder.addCase(dealsView.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(dealsView.fulfilled, (state, action) => {
      state.loading = false;
      state.dealView = action.payload;
    });
    builder.addCase(dealsView.rejected, (state, action) => {
      state.loading = false;
      state.dealView = [];
      state.error = action.error.message;
    });

    builder.addCase(approvependingdeal.pending, (state) => {
      state.approveSubmitLoading = true;
      state.error = "";
    });
    builder.addCase(approvependingdeal.fulfilled, (state, action) => {
      state.approveSubmitLoading = false;
      state.approvedealform = action.payload;
    });
    builder.addCase(approvependingdeal.rejected, (state, action) => {
      state.approveSubmitLoading = false;
      state.error = action.payload;
    });

    builder.addCase(Rejectdeal.pending, (state) => {
      state.cancelLoading = true;
      state.cancelError = "";
    });
    builder.addCase(Rejectdeal.fulfilled, (state, action) => {
      state.cancelLoading = false;
      state.cancelError = "";
      state.rejectDealform = action.payload;
    });
    builder.addCase(Rejectdeal.rejected, (state, action) => {
      state.cancelLoading = false;
      state.cancelError = action.payload;
    });
    builder.addCase(sendaggrement.pending, (state) => {
      state.cancelLoading = true;
      state.cancelError = "";
    });
    builder.addCase(sendaggrement.fulfilled, (state, action) => {
      state.cancelLoading = false;
      state.sendagreeform = action.payload;
      state.cancelError = "";
    });
    builder.addCase(sendaggrement.rejected, (state, action) => {
      state.cancelLoading = false;
      state.cancelError = action.payload;
    });
    builder.addCase(Cancledeal.pending, (state) => {
      state.cancelLoading = true;
      state.cancelError = "";
    });
    builder.addCase(Cancledeal.fulfilled, (state, action) => {
      state.cancelLoading = false;
      state.cancleDealform = action.payload;
      state.cancelError = "";
    });
    builder.addCase(Cancledeal.rejected, (state, action) => {
      state.cancelLoading = false;
      state.cancelError = action.payload;
    });
    builder.addCase(Disbursedeal.pending, (state) => {
      state.disburseLoading = true;
      state.disburseError = "";
    });
    builder.addCase(Disbursedeal.fulfilled, (state, action) => {
      state.disburseLoading = false;
      state.disburseDealform = action.payload;
      state.disburseError = "";
    });
    builder.addCase(Disbursedeal.rejected, (state, action) => {
      state.disburseLoading = false;
      state.disburseError = action.payload;
    });

    builder.addCase(getAggrementStatus.pending, (state) => {
      state.agreeStatusloading = true;
      state.error = "";
    });
    builder.addCase(getAggrementStatus.fulfilled, (state, action) => {
      state.agreeStatusloading = false;
      state.aggrementData = action.payload.response;
    });
    builder.addCase(getAggrementStatus.rejected, (state, action) => {
      state.agreeStatusloading = false;
      state.error = action.payload;
    });

    builder.addCase(sendAgreementReminder.pending, (state) => {
      state.sendAgreeloading = true;
      state.error = "";
    });
    builder.addCase(sendAgreementReminder.fulfilled, (state, action) => {
      state.sendAgreeloading = false;
    });
    builder.addCase(sendAgreementReminder.rejected, (state, action) => {
      state.sendAgreeloading = false;
      state.error = action.payload;
    });

    builder.addCase(sendOverdueReminder.pending, (state) => {
      state.sendRemainderLoading = true;
      state.error = "";
    });
    builder.addCase(sendOverdueReminder.fulfilled, (state, action) => {
      state.sendRemainderLoading = false;
    });
    builder.addCase(sendOverdueReminder.rejected, (state, action) => {
      state.sendRemainderLoading = false;
      state.error = action.payload;
    });

    builder.addCase(sendRepaymentReminder.pending, (state) => {
      state.sendRemainderLoading = true;
      state.error = "";
    });
    builder.addCase(sendRepaymentReminder.fulfilled, (state, action) => {
      state.sendRemainderLoading = false;
    });
    builder.addCase(sendRepaymentReminder.rejected, (state, action) => {
      state.sendRemainderLoading = false;
      state.error = action.payload;
    });

    builder.addCase(Republishdeal.pending, (state) => {
      state.cancelLoading = true;
      state.cancelError = "";
    });
    builder.addCase(Republishdeal.fulfilled, (state, action) => {
      state.cancelLoading = false;
      state.republishDealform = action.payload;
      state.cancelError = "";
    });
    builder.addCase(Republishdeal.rejected, (state, action) => {
      state.cancelLoading = false;
      state.cancelError = action.payload;
    });

    builder.addCase(dealsUnderBusiness.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(dealsUnderBusiness.fulfilled, (state, action) => {
      state.loading = false;
      state.dealunderBus = action.payload;
    });
    builder.addCase(dealsUnderBusiness.rejected, (state, action) => {
      state.loading = false;
      state.dealunderBus = [];
      state.error = action.error.message;
    });

    builder.addCase(approveDeals.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(approveDeals.fulfilled, (state, action) => {
      state.loading = false;
      state.approvedeal = action.payload;
    });
    builder.addCase(approveDeals.rejected, (state, action) => {
      state.loading = false;
      state.approvedeal = {};
      state.error = action.payload;
    });

    builder.addCase(dealDetailedView.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(dealDetailedView.fulfilled, (state, action) => {
      state.loading = false;
      state.detailedview = action.payload;
    });
    builder.addCase(dealDetailedView.rejected, (state, action) => {
      state.loading = false;
      state.detailedview = [];
      state.error = action.error.message;
    });

    builder.addCase(dealLevelFunding.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(dealLevelFunding.fulfilled, (state, action) => {
      state.loading = false;
      state.fundDeals = action.payload;
    });
    builder.addCase(dealLevelFunding.rejected, (state, action) => {
      state.loading = false;
      state.fundDeals = [];
      state.error = action.error.message;
    });

    builder.addCase(getExpiryDays.fulfilled, (state, action) => {
      state.expiryDays = action.payload;
    });

    builder.addCase(count.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(count.fulfilled, (state, action) => {
      state.loading = false;
      state.CountData = action.payload;
    });
    builder.addCase(count.rejected, (state, action) => {
      state.loading = false;
      state.CountData = [];
      state.error = action.error.message;
    });

  },

  reducers: {},
});

export const { updateStatus } = dealsSlice.actions;

export default dealsSlice.reducer;
